import HotelSeekList from "@/page/distributor/hotel/components/hotelSeekList";
import SiteSearch from "@/page/distributor/hotel/components/siteSearch";
import HotelList from "@/page/distributor/hotel/components/hotelList";

// 国内酒店城市组件
import HotelDomesticCitySelector from "yinzhilv-js-sdk/frontend/common-project/component/yinzhilv/hotel-domestic-city-selector/1.0.0/index.vue";
// 国外酒店城市组件
import HotelForeignCitySelector from "yinzhilv-js-sdk/frontend/common-project/component/yinzhilv/hotel-foreign-city-selector/1.0.0/index.vue";

import { queryHotelBrand, getCityList } from "@/lib/data-service/hotel";
import hotelCommonBuildSolrGetHotelListBySolr from "@/lib/data-service/hotel/hotelCommonBuildSolrGetHotelListBySolr";
import { STATUS } from "@/lib/deprecated/utils/status";
const SUCCESS_CODE = STATUS.success;
export default {
  name: "hotelSearch",
  components: {
    HotelSeekList,
    HotelList,
    SiteSearch,
    HotelDomesticCitySelector,
    HotelForeignCitySelector,
  },
  data() {
    return {
      hotelInlandCity: null,
      hotelForeignCity: null,
      pickerBeginDateBefore: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //
        },
      },
      pickerOption: this.setTime(),
      formData: {
        currentPage: 1, //当前页码
        pageSize: 10, //每页条数
        checkInTime: "",
        checkOutTime: "",
        keyword: "",
        cityId: "",
        cityName: "",
      },
      totalPage: null, //总页数
      queryList: [], //搜索后的酒店列表
      showList: {
        hotelStar: [],
        brand: [],
        hotel: [],
      },
      navList: [
        { text: "综合", ico: "" },
        // { text: "价格", ico: "el-icon-bottom", statu: false },
        { text: "销量", ico: "el-icon-bottom", statu: false },
      ],
      house: {
        title: "房态:",
        type: "house",
        list: [
          {
            value: "",
            label: "不限",
          },
          {
            value: "1",
            label: "保留房",
          },
          {
            value: "2",
            label: "待查",
          },
          {
            value: "3",
            label: "满房",
          },
          {
            value: "4",
            label: "限时确认",
          },
        ],
        statu: false,
        moreStatu: false,
      }, //条件选项列表
      hotel: {
        title: "酒店主题:",
        type: "hotel",
        list: [
          {
            value: "",
            label: "不限",
          },
          {
            value: "biz",
            label: "商务酒店",
          },
          {
            value: "spa",
            label: "温泉SPA",
          },
          {
            value: "economy",
            label: "经济型酒店",
          },
          {
            value: "vacation",
            label: "山水名胜",
          },
          {
            value: "huiyi",
            label: "会议酒店",
          },
          {
            value: "1hx",
            label: "冰雪假期",
          },
          {
            value: "2hb",
            label: "阳光沙滩",
          },
          {
            value: "3dm",
            label: "大漠绿洲",
          },
          {
            value: "4gz",
            label: "古镇风情",
          },
          {
            value: "5dj",
            label: "高尔夫度假",
          },
          {
            value: "6bw",
            label: "台湾风情",
          },
          {
            value: "7ds",
            label: "都市购物",
          },
          {
            value: "8hd",
            label: "海岛休闲",
          },
          {
            value: "9zt",
            label: "主题乐园",
          },
          {
            value: "10gd",
            label: "高端奢华",
          },
          {
            value: "11sw",
            label: "商务精选",
          },
          {
            value: "12bc",
            label: "博彩娱乐",
          },
        ],
        statu: true,
        moreStatu: true,
      }, //条件选项列表
      hotelStar: {
        title: "酒店星级:",
        type: "hotelStar",
        list: [
          {
            value: null,
            label: "不限",
          },
          {
            value: 2,
            label: "经济型",
          },
          {
            value: 3,
            label: "舒适型",
          },
          {
            value: 4,
            label: "高档型",
          },
          {
            value: 5,
            label: "豪华型",
          },
        ],
        statu: false,
        moreStatu: true,
      }, //条件选项列表
      payment: {
        title: "付款方式:",
        type: "payment",
        list: [
          {
            value: "",
            label: "不限",
          },
          {
            value: "0",
            label: "预付",
          },
          {
            value: "1",
            label: "现付",
          },
        ],
        statu: false,
        moreStatu: false,
      }, //条件选项列表
      brand: {
        title: "品牌:",
        type: "brand",
        list: [],
        statu: true,
        moreStatu: true,
      }, //条件选项列表
      footNav: [
        {
          text: "及时响应",
          img:
            "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/default-v2/distributor/label1.jpg",
        },
        {
          text: "资金安全",
          img:
            "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/default-v2/distributor/label2.jpg",
        },
        {
          text: "可信供应商",
          img:
            "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/default-v2/distributor/label3.jpg",
        },
        {
          text: "售后保障",
          img:
            "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/default-v2/distributor/label4.jpg",
        },
        {
          text: "产品保障",
          img:
            "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/default-v2/distributor/label5.jpg",
        },
        {
          text: "价格保障",
          img:
            "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/default-v2/distributor/label6.jpg",
        },
        {
          text: "省心保障",
          img:
            "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/default-v2/distributor/label7.jpg",
        },
        {
          text: "投诉维权",
          img:
            "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/default-v2/distributor/label8.jpg",
        },
        {
          text: "培训保障",
          img:
            "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/default-v2/distributor/label9.jpg",
        },
      ],
      cityTypeList: [
        {
          value: 1,
          label: "国内",
        },
        {
          value: 2,
          label: "港澳台",
        },
        {
          value: 3,
          label: "国际",
        },
      ], //酒店tag列表
      pageSize: 1,
      sortStyle: 0,
      weekPrice: [], //日历价格
      cityName: "", //搜索城市名称
      siteList: [], //搜索城市列表
      star: null, //酒店星级回显
      cityType: 1, //酒店地区类型 1:国内,2:港澳台,3:国际ountryType
      HongkongName: "",
      HongkongList: [
        {
          value: "30000898",
          label: "香港",
        },
        {
          value: "70139",
          label: "澳门",
        },
        {
          value: "30001017",
          label: "台湾",
        },
      ],
      pagingStatu: {},
      checkOutTimeStatu: false, //退房日期状态
      tagList: {}, //指引栏显示列表
      foreignSiteList: [], //国外地址
      inlandSiteList: [], //国内地址
      cityListStatu: true,
      loading: false,

      pager: {
        haveNext: false,
        havePrev: false,
      },

      advantage: [
        {
          text: "资源丰富",
          img:
            "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/2020/09/04/buyer_footer001.png",
        },
        {
          text: "价格优势",
          img:
            "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/2020/09/04/buyer_footer002.png",
        },
        {
          text: "灵活结算",
          img:
            "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/2020/09/04/buyer_footer003.png",
        },
        {
          text: "资金安全",
          img:
            "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/2020/09/04/buyer_footer004.png",
        },
        {
          text: "省心服务",
          img:
            "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/2020/09/04/buyer_footer005.png",
        },
        {
          text: "售后保障",
          img:
            "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/2020/09/04/buyer_footer006.png",
        },
        {
          text: "价值服务",
          img:
            "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/2020/09/04/buyer_footer007.png",
        },
        {
          text: "多元拓展",
          img:
            "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/2020/09/04/buyer_footer008.png",
        },
      ],
    };
  },
  watch: {
    hotelInlandCity(val) {
      const formData = this.formData;
      if (val) {
        formData.cityName = val.cityCn;
        formData.cityId = val.cityId;
      }
    },
    hotelForeignCity(val) {
      const formData = this.formData;
      if (val) {
        formData.cityName = val.cityCn;
        formData.cityId = val.cityId;
      }
    },
    cityName(val) {
      if (!val) {
        this.formData.cityId = "";
        this.formData.cityName = "";
      }
    },
  },
  created() {
    this.init();
  },
  mounted() {
    const cityType = this.cityType;
    const cityId = this.formData.cityId;
    if (cityId) {
      if (cityType == 1) {
        this.hotelInlandCity = { cityId };
      } else if (cityType == 3) {
        this.hotelForeignCity = { cityId };
      }
    }
  },
  methods: {
    init() {
      this.getHotelBrand();
      this.getHotelTheme();
      this.getSeekInfo();
      this.getList();
    },
    handleSizeChange(val) {
      this.formData.pageSize = val;
      this.formData.currentPage = 1;
      this.getList();
    },

    getSeekInfo() {
      let data = JSON.parse(this.$route.query.data);
      let formData = this.formData;
      if (!data.checkInTime) {
        formData.checkInTime = this.$moment().format("YYYY-MM-DD");
        formData.checkOutTime = this.$moment()
          .subtract(-1, "days")
          .format("YYYY-MM-DD");
      } else {
        formData.checkInTime = data.checkInTime;
        formData.checkOutTime = data.checkOutTime;
      }
      if (data.cityName || data.hotelStar || data.keyword) {
        this.cityName = data.cityName || "";
        let star = data.hotelStar || "";
        if (star) {
          this.star =
            star == 2 ? 1 : star == 3 ? 2 : star == 4 ? 3 : star == 5 ? 4 : 0;
          let startList = this.hotelStar.list.filter(
            (item) => item.value === star
          );
          this.tagList.hotelStar = startList;
        }
        this.cityType = Number(data.countryType) || 1;
        this.HongkongName = data.cityId || "";
        this.formData = Object.assign(this.formData, data);
      }
    },
    //切换城市
    getCityInfo(val) {
      const formData = this.formData;
      formData.cityName = val.cityCn;
      formData.cityId = val.cityId;
    },
    //港澳台目的城市
    HongkongSelect(val) {
      let formData = this.formData;
      formData.cityId = val;
    },
    //分页
    handleCurrentChange(val) {
      this.formData.currentPage = val;
      this.getList();
    },
    //获取城市列表
    _getCityList(val) {
      if (val == 1) {
        if (this.inlandSiteList.length != 0) {
          this.siteList = this.inlandSiteList;
          return;
        }
      } else if (val == 3) {
        if (this.foreignSiteList.length != 0) {
          this.siteList = this.foreignSiteList;
          return;
        }
      }

      getCityList({ countryType: val }).then((res) => {
        if (res.code === SUCCESS_CODE) {
          this.siteList = res.citys;
          val == 1
            ? (this.inlandSiteList = res.citys)
            : val == 3
            ? (this.foreignSiteList = res.citys)
            : "";
        }
      });
    },
    //分页小按钮上面
    pagingBtn(type) {
      if (type == "minus") {
        if (
          this.pagingStatu.previousPage == 0 ||
          this.formData.currentPage === 1
        )
          return;
        this.formData.currentPage--;
      } else if (type == "plus") {
        if (this.pagingStatu.nextPage == 0) return;
        this.formData.currentPage++;
      }
      this.getList();
    },
    //排序状态查询
    sortHotel(index) {
      this.navList[index].statu = !this.navList[index].statu;
      this.navList[index].statu
        ? (this.navList[index].ico = "el-icon-top")
        : (this.navList[index].ico = "el-icon-bottom");
    },
    //日历时间查询
    setTime() {
      let _this = this;
      return {
        disabledDate: (time) => {
          if (_this.formData.checkInTime) {
            if (typeof _this.formData.checkInTime == "object") {
              return (
                time.getTime() - 1000 * 3600 * 24 < _this.formData.checkInTime
              );
            } else {
              return (
                time.getTime() - 1000 * 3600 * 24 <
                this.$moment(_this.formData.checkInTime)._d
              );
            }
          } else {
            return time.getTime() < Date.now();
          }
        },
      };
    },
    //删除tagList
    deleteTagList(list, index, type) {
      list.splice(index, 1);
      let data = this.formData;
      let arr = [];
      if (type == "hotelStar") {
        arr = list.map((item) => {
          return item.value;
        });
        data.hotelStar = arr.join(",");
      } else if (type == "hotel") {
        arr = list.map((item) => {
          return item.value;
        });
        data.hotelTheme = arr.join(",");
      } else if (type == "brand") {
        arr = list.map((item) => {
          return item.hotelBrandId;
        });
        data.hotelBrand = arr.join(",");
      }
      this.showList[type] = list;
      this.getList("seek");
      this.$forceUpdate();
    },
    //排序查询
    sortSeek(index) {
      let data = this.formData;
      if (index === 0) {
        //综合
        delete data.priceSort;
        delete data.salesSort;
      }
      if (index === 1) {
        //销量
        data.salesSort = "asc";
        delete data.priceSort;
        this.sortHotel(index);
      }
      data.salesSort = data.salesSort && sortType(this.navList[index]);
      function sortType(navObj) {
        let state = {
          navObj: navObj || {},
        };
        if (Object.keys(state.navObj).length === 0) {
          return console.error("navObj null");
        }
        return state.navObj.statu ? "desc" : "asc";
      }
      this.sortStyle = index;
      this.getList();
    },
    //状态查询
    clickItem(val) {
      let data = this.formData;
      let _this = this;
      let navList = [];
      let arr = [];
      if (verdice(val) == false) return this.getList("seek");
      if (!this.tagList[val.type]) {
        navList.push(val.value);
        this.tagList[val.type] = navList;
      } else {
        let statu = this.tagList[val.type].some((item) => {
          if (item == val.value) {
            return true;
          }
          return false;
        });
        if (!statu) {
          this.tagList[val.type].push(val.value);
        }
      }
      if (val.type === "house") {
        data.roomStatus = val.value.value;
      } else if (val.type === "hotel") {
        arr = this.tagList[val.type].map((item) => {
          return item.value;
        });
        data.hotelTheme = arr.join(",");
      } else if (val.type === "hotelStar") {
        arr = this.tagList[val.type].map((item) => {
          return item.value;
        });
        data.hotelStar = arr.join(",");
      } else if (val.type === "payment") {
        data.paymentType = val.value.value;
      } else if (val.type === "brand") {
        arr = this.tagList[val.type].map((item) => {
          return item.hotelBrandId;
        });
        data.hotelBrand = arr.join(",");
      }

      function verdice(val) {
        if (val.type == "hotel") {
          if (!val.value.value) {
            delete _this.tagList[val.type];
            data.hotelTheme = val.value.value;
            _this.$forceUpdate();
            return false;
          }
        } else if (val.type == "hotelStar") {
          if (!val.value.value) {
            delete _this.tagList[val.type];
            data.hotelStar = val.value.value;
            _this.$forceUpdate();
            return false;
          }
        } else {
          if (!val.value.hotelBrandId) {
            delete _this.tagList[val.type];
            data.hotelBrand = "";
            _this.$forceUpdate();
            return false;
          }
        }
      }
      this.getList("seek");
    },
    //多选
    clickItemMore(val) {
      let showList = [];
      let data = this.formData;
      let list;
      list = val.value.map((item) => {
        return item;
      });
      if (val.type === "house") {
      } else if (val.type === "hotel") {
        data.hotelTheme = list.join(",");
      } else if (val.type === "hotelStar") {
        data.hotelStar = list.join(",");
      } else if (val.type === "payment") {
      } else if (val.type === "brand") {
        data.hotelBrand = list.join(",");
      }
      this.getList();
    },
    //酒店品牌
    getHotelBrand() {
      queryHotelBrand().then((res) => {
        if (res.code === SUCCESS_CODE) {
          let arr = res.pageResult.pageData.slice(0, 8),
            initObj = { hotelBrandId: "", hotelBrandName: "不限" };
          arr.unshift(initObj);
          this.brand.list = arr;
          let allList = res.pageResult.pageData;
          allList.unshift(initObj);
          this.brand.allList = allList;
        }
      });
    },
    //酒店主题
    getHotelTheme() {
      let newArr = this.hotel.list;
      let arr = this.hotel.list.slice(0, 9);
      this.hotel.list = arr;
      this.hotel.allList = newArr;
    },
    //获取查询酒店列表
    getList(text) {
      let data = JSON.parse(JSON.stringify(this.formData));
      data.productType = 3;
      data.countryType = this.cityType;
      let _this = this;
      if (!data.checkInTime) {
        this.$message({ type: "warning", message: "请选择入住时间" });
        return;
      } else if (!data.checkOutTime) {
        this.$message({ type: "warning", message: "请选择退房时间" });
        return;
      }
      data.checkInDate = this.$moment(data.checkInTime).format("YYYY-MM-DD");
      data.checkOutDate = this.$moment(data.checkOutTime).format("YYYY-MM-DD");
      delete data.checkInTime;
      delete data.checkOutTime;

      if (text === "seek") {
        data.currentPage = 1;
      }
      this.loading = true;
      this.queryList = [];
      try {
        hotelCommonBuildSolrGetHotelListBySolr(data)
          .then((res) => {
            if (res.code === SUCCESS_CODE) {
              this.queryList = res.dataMap.rows;
              this.totalPage = res.dataMap.total;
              this.pagingStatu = {
                nextPage: res.dataMap.nextPage,
                previousPage: !res.dataMap.rows.length
                  ? 0
                  : res.dataMap.previousPage,
              };

              const data = res.dataMap;

              const pager = this.pager;
              pager.havePrev = data.previousPage === "1" ? true : false;
              pager.haveNext = data.nextPage === "1" ? true : false;
              this.loading = false;
            }
          })
          .catch(() => {
            this.loading = false;
          });
      } catch {
        this.loading = false;
      }
    },
  },
};
